var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"px-8 py-3 rounded-3xl text-white text-lg font-medium add-button",on:{"click":_vm.clickEvent}},[_c('span',{staticClass:"icon-plus"}),_vm._v(" Tambah ")])
}
var staticRenderFns = []

export { render, staticRenderFns }